export const FEATURE_SEGMENTS_DESC_MIN_LENGTH: number = 20;
